import {SecureService} from "@/services/superclasses/secure-service";
import {MemberLog} from "@/interfaces/member-log";

const api = window.contextPath + '/rest/member-logs';

export class MemberLogSecureService extends SecureService {

    public search = async (args: {
        first?: number,
        max?: number
    }): Promise<MemberLog[]> => {
        return this.data(await this.get<MemberLog[]>(api,
            {
                params: args
            }))
    }
}

export const memberLogSecureService = new MemberLogSecureService()